export default "__VITE_ASSET__GIsIElf0__"